import { useRouteChangeStatus } from "@/hooks";
import isShowValuePlanLabel from "@/lib/isShowValuePlanLabel";
import styles from "@/styles/Video.module.scss";
import Image from "next/legacy/image";
export default function PlayerThumbnail({ poster, watch, mediaLoaded, state }) {
  const { isRouting } = useRouteChangeStatus();
  const channelId = Number(watch?.episode?.channel?.id);

  const showValuePlanLabel = (() => {
    if (!channelId) {
      return false;
    }
    return (
      isShowValuePlanLabel({ channelId }) &&
      ((!mediaLoaded && !isRouting) ||
        (state?.overlay && state?.reason !== "next_episode"))
    );
  })();

  const showThumbnail = poster && !mediaLoaded && !state?.overlay && !isRouting;

  return (
    <div>
      {showThumbnail && !!poster && (
        <Image
          src={poster}
          alt={"thumbnail"}
          layout="fill"
          objectFit="contain"
        ></Image>
      )}
      {/* 既存と挙動は合わせて、バリュープランラベルは非表示にする */}
      {showValuePlanLabel && false && (
        <div>
          <div className={styles.valueplanLabel}>
            <Image
              src={"/images/valueplan_label.png"}
              alt={"valueplan_label"}
              layout="responsive"
              width={1000}
              height={247}
            ></Image>
          </div>
          <div className={styles.leminoLogo}>
            <Image
              src={"/images/lemino_logo.png"}
              alt={"lemino_logo"}
              layout="fill"
              objectFit="contain"
            ></Image>
          </div>
        </div>
      )}
    </div>
  );
}
